export default [
  { label: 'Alphabetical', value: 'alphabetical' },
  { label: 'Avalanche', value: 'interestHighest' },
  { label: 'Custom Order', value: 'paydownOrder' },
  { label: 'Progress - Least', value: 'progressLeast' },
  { label: 'Progress - Most', value: 'progressMost' },
  { label: 'Snowball', value: 'balanceLowest' },
];



// WEBPACK FOOTER //
// ./src/constants/sortTypes.js